import { Component, Input, OnInit } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { DataCafService } from 'src/app/services/data-caf.service';
import { DataCAF } from 'src/app/shared/object/data_caf.model';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-view-folios',
  templateUrl: './view-folios.component.html',
  styleUrls: ['./view-folios.component.scss']
})
export class ViewFoliosComponent implements OnInit {
  @Input() codigos_dte: number[];
  @Input() contadorFacturas: number;
  codigo_dte_seleccionado: number;
  listDataCaf: DataCAF[];
  dataCaf: DataCAF;
  loading: boolean;
  existFolios: boolean;

  constructor(
    private dataCafService: DataCafService,
    private accesolocalstorage: SecurityService
  ) { }

  ngOnInit() {
    this.initSuscriberChange()
    this.obtenerFolios();
    this.existFolios = false;
  }

  obtenerFolios() {
    this.loading = true;
    const fecha = new Date().toISOString();
    const rut_empresa = this.accesolocalstorage.getRutEmpresa();
    const inputParams = {
      entidad: {
        codigo_dte: 0,
        nombre_dte: fecha,
        fecha_emision: fecha,
        fecha_vencimiento: fecha,
        folios_disponibles: 0,
        ultimo_folio: 0,
        folios_inicial: 0,
        folios_final: 0,
        codigos_dte: this.codigos_dte.join(','),
        rut_empresa,
      }
    }
    this.dataCafService.getDataCaf(inputParams, (response) => {
      this.loading = false;
      const { respuesta } = response;
      if (!respuesta) alert('No se encontraron datos')
      else {
        if (respuesta.length > 0) {
          this.listDataCaf = respuesta.map((x:any) => ({
            codigo_dte: x.codigo_dte,
            nombre_dte: x.nombre_dte,
            folios_disponibles: x.folios_disponibles,
            fecha_emision: x.fecha_emision,
            fecha_vencimiento: x.fecha_vencimiento,
            folios_inicial: x.folios_inicial,
            folios_final: x.folios_final,
            ultimo_folio: x.ultimo_folio,
          }))
          const totalFoliosDisponibles = this.listDataCaf.reduce((a: number, e: DataCAF) => a + e.folios_disponibles, 0);
          this.dataCaf = this.listDataCaf.find(x => x.codigo_dte === this.codigo_dte_seleccionado)
          this.dataCaf.folios_disponibles = totalFoliosDisponibles;

          this.existFolios = (this.dataCaf !== null && this.dataCaf !== undefined) || this.dataCaf.folios_disponibles > 0;
        }

      }
      this.loading = false;
    }) 
  }
  // Suscribirse a los cambios de la variable del servicio
  initSuscriberChange() {
    this.dataCafService.codigo_dte_seleccionada$
      .pipe(distinctUntilChanged())
      .subscribe((codigo_dte: number) => {
        this.codigo_dte_seleccionado = codigo_dte;
        if (codigo_dte && this.listDataCaf && this.listDataCaf.length > 0) {
          this.dataCaf = this.listDataCaf.find(x => x.codigo_dte === codigo_dte)
          if (!this.dataCaf) {
            this.dataCaf = {
              codigo_dte: codigo_dte,
              nombre_dte: '',
              folios_disponibles: 0,
              fecha_emision: '',
              fecha_vencimiento: '',
              folios_inicial: 0,
              folios_final: 0,
              ultimo_folio: 0,
            }
          }
        }
      }
    )
  }
}
